var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 24,
    height: 18,
    rx: 3,
    fill: "#2D2D2D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92924 11.3641L4.78503 13.1267C4.7786 13.0562 4.77504 12.9849 4.77504 12.9128C4.77504 11.619 5.83771 10.5701 7.1486 10.5701C7.85782 10.5701 8.49434 10.8773 8.92924 11.3641ZM7.14863 8.81818C9.10417 8.81818 10.7434 10.1536 11.1818 11.951L9.50973 12.6726L9.50934 12.6691L7.7987 13.4109L3.69505 15.1818C3.25605 14.5323 3 13.752 3 12.9128C3 10.6513 4.85737 8.81818 7.14863 8.81818Z",
    fill: "#FFFFFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.36363 15.6821C8.05946 17.247 6.33417 17.4005 4.81818 16.237L5.67471 14.5907C6.53735 15.2425 7.40394 15.1368 8.27455 14.2727L9.36363 15.6821Z",
    fill: "#FFFFFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1917 14.9842L11.1818 7H12.5872V14.7686C12.5872 14.8431 12.5957 14.9088 12.6866 14.9467L13.9091 15.4585L13.3583 17L11.9262 16.3478C11.3831 16.1005 11.1927 15.7421 11.1917 14.9842Z",
    fill: "#FFFFFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6364 14.5994C16.0782 14.189 15.7189 13.5484 15.7189 12.828C15.7189 12.1875 16.0032 11.6102 16.4583 11.2014L15.4966 9.72729C14.5299 10.4517 13.9091 11.5709 13.9091 12.828C13.9091 14.1829 14.6298 15.3783 15.7281 16.0909L16.6364 14.5994Z",
    fill: "#2191C3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3811 10.937C17.6237 10.839 17.8853 10.7853 18.158 10.7853C19.1411 10.7853 19.9795 11.4793 20.3069 12.4545L22.0909 12.2872C21.6603 10.2966 20.0634 8.81818 18.158 8.81818C17.6196 8.81818 17.1062 8.93722 16.6364 9.15144L17.3811 10.937Z",
    fill: "#FAEC32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2902 13.3636C20.2305 14.4872 19.1973 15.3817 17.9313 15.3817C17.7329 15.3817 17.5403 15.3594 17.3562 15.3181L16.6364 16.8147C17.0441 16.9343 17.4791 17 17.9313 17C20.1736 17 22.001 15.4082 22.0909 13.4146L20.2902 13.3636Z",
    fill: "#D0362B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElo);
export default __webpack_public_path__ + "static/media/elo.5464358e664789548e102f2bcaf34808.svg";
export { ForwardRef as ReactComponent };